export default {"src":"/_next/static/media/company-name.74e3efb6.svg","height":24,"width":206};